import { render, staticRenderFns } from "./inputPage.vue?vue&type=template&id=024560a4&scoped=true&"
import script from "./inputPage.vue?vue&type=script&lang=ts&"
export * from "./inputPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024560a4",
  null
  
)

export default component.exports